import { useUserProfile } from '../contexts/UserProfileContext'

/** Profile key the compact-tables preference lives under — this UI's own. */
export const COMPACT_TABLES_KEY = 'ruiCompactTables'

/**
 * Whether lists start in their compact view, set once in the preferences and
 * kept in the user profile so it follows the user between browsers. A list can
 * still be switched on its own from its column picker.
 */
export function useCompactTables() {
  const { read, save } = useUserProfile()
  const compact = read<unknown>(COMPACT_TABLES_KEY, false) === true

  // Off is the default, so it is stored as no key at all.
  const setCompact = (next: boolean) => save({ [COMPACT_TABLES_KEY]: next ? true : null })

  return { compact, setCompact }
}
